import Logo, { LogoNameType } from "../Logo";

export type LogoTileProps = {
  logo: LogoNameType;
};

export const LogoTile = ({ logo }: LogoTileProps) => (
  <div className="size-full max-w-[90px] flex items-center justify-center">
    <Logo type={logo} isFullColor />
  </div>
);
